/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ venueName: NonNullable<unknown> }} Venueroomqralt3Inputs */

const en_venueroomqralt3 = /** @type {(inputs: Venueroomqralt3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Live Room code for ${i?.venueName}`)
};

const de_venueroomqralt3 = /** @type {(inputs: Venueroomqralt3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Live-Room-Code für ${i?.venueName}`)
};

/**
* | output |
* | --- |
* | "Live Room code for {venueName}" |
*
* @param {Venueroomqralt3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const venueroomqralt3 = /** @type {((inputs: Venueroomqralt3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Venueroomqralt3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_venueroomqralt3(inputs)
	return de_venueroomqralt3(inputs)
});
export { venueroomqralt3 as "venueRoomQrAlt" }